import { cn } from '@/utils/utils';

export const LocationIcon = ({
    className = '',
    fill = 'var(--clr-primary-web)'
}) => {
    return (
        <div className={className}>
            <svg
                width='15'
                height='16'
                viewBox='0 0 15 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clipPath='url(#clip0_939_1026)'>
                    <g clipPath='url(#clip1_939_1026)'>
                        <path
                            d='M7.42577 9.30385C5.75316 9.30385 4.39719 7.94788 4.39719 6.27526C4.39719 4.60265 5.75316 3.24668 7.42577 3.24668V0.741943C4.25418 0.741943 1.68311 3.31302 1.68311 6.48461C1.68311 9.6562 7.42568 15.4494 7.42577 15.4494V9.30385Z'
                            fill={fill}
                        />
                        <path
                            d='M7.42456 0.741943V3.24668C9.09717 3.24668 10.4531 4.60265 10.4531 6.27526C10.4531 7.94788 9.09717 9.30385 7.42456 9.30385V15.4494C7.42456 15.4494 13.1672 9.6562 13.1672 6.48461C13.1672 3.31302 10.5962 0.741943 7.42456 0.741943Z'
                            fill={fill}
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id='clip0_939_1026'>
                        <rect
                            width='15'
                            height='15'
                            fill='white'
                            transform='translate(0 0.5)'
                        />
                    </clipPath>
                    <clipPath id='clip1_939_1026'>
                        <rect
                            width='11.4855'
                            height='14.7075'
                            fill='white'
                            transform='translate(1.68286 0.741943)'
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export const ClockIcon = ({
    className = '',
    color = 'var(--clr-primary-web)'
}) => {
    return (
        <div className={className}>
            <svg
                width='15'
                height='16'
                viewBox='0 0 15 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clipPath='url(#clip0_939_1032)'>
                    <path
                        d='M7.50024 4.25V8.53571L10.286 9.92857'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M14.2781 9.60719C13.5526 12.6787 10.7933 14.9643 7.50017 14.9643C3.65391 14.9643 0.535889 11.8464 0.535889 8.00005C0.535889 4.15378 3.65391 1.03577 7.50017 1.03577C10.187 1.03577 12.5185 2.55731 13.68 4.78577'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                    />
                    <path
                        d='M14.4642 2.64294V5.32152H11.7856'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_939_1032'>
                        <rect
                            width='15'
                            height='15'
                            fill='white'
                            transform='translate(0 0.5)'
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export const InfoIcon = ({
    className = '',
    color = 'var(--clr-primary-web)'
}) => {
    return (
        <div className={className}>
            <svg xmlns='http://www.w3.org/2000/svg' width='15' height='16' viewBox='0 0 15 16' fill='none'>
                <g clipPath='url(#clip0_861_2421)'>
                    <path
                        d='M7.49999 14.9643C11.3463 14.9643 14.4643 11.8463 14.4643 7.99999C14.4643 4.15372 11.3463 1.03571 7.49999 1.03571C3.65372 1.03571 0.535706 4.15372 0.535706 7.99999C0.535706 11.8463 3.65372 14.9643 7.49999 14.9643Z'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M5.89294 11.2143H9.10723'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.50008 11.2143V7.46429H6.42865'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.50003 5.0536C7.3521 5.0536 7.23218 4.93367 7.23218 4.78574C7.23218 4.63781 7.3521 4.51788 7.50003 4.51788'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.5 5.0536C7.64793 5.0536 7.76786 4.93367 7.76786 4.78574C7.76786 4.63781 7.64793 4.51788 7.5 4.51788'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_861_2421'>
                        <rect width='15' height='15' fill='white' transform='translate(0 0.5)' />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export const EngineSizeIcon = ({ className = '', color = '#7E7E7E' }) => {
    return (
        <div className={className}>
            <svg
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M5.67678 10.1795C5.42889 10.1103 5.16748 10.0732 4.89738 10.0732C3.29706 10.0732 2 11.3706 2 12.9706C2 14.5709 3.29706 15.868 4.89738 15.868C6.42656 15.868 7.67887 14.6839 7.78704 13.1825'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6.48012 13.2641C6.34201 14.0119 5.68494 14.5802 4.8975 14.5802C4.00993 14.5802 3.28784 13.8581 3.28784 12.9705C3.28784 12.0829 4.00993 11.3608 4.8975 11.3608C5.40004 11.3608 5.84977 11.5923 6.14498 11.9545'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M17.337 6.48832V6.488H17.3367C16.4337 5.14812 14.9892 4.38643 13.1861 4.0072C12.9533 3.95794 12.7489 4.16945 12.8068 4.40027L13.1935 5.94748C13.1938 5.94844 13.1938 5.94909 13.1941 5.95005'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.82251 10.3266L4.25342 8.7417'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.22836 11.7462L6.61572 11.1274'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M17.5507 11.4199C17.8353 11.8684 18.0001 12.4002 18.0001 12.9703C18.0001 14.5707 16.703 15.8677 15.1027 15.8677C13.5024 15.8677 12.2053 14.5707 12.2053 12.9703C12.2053 12.8606 12.2114 12.7524 12.2234 12.6458'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M16.2512 11.8436C16.5364 12.1343 16.7125 12.5322 16.7125 12.9704C16.7125 13.8579 15.9904 14.58 15.1028 14.58C14.2153 14.58 13.4932 13.8579 13.4932 12.9704C13.4932 12.4089 13.7819 11.9138 14.2191 11.626'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M15.3552 12.1357L16.2508 11.8437L17.5505 11.4201L17.6149 11.3991C17.7552 11.3534 17.8373 11.225 17.8373 11.092C17.8373 11.0241 17.8154 10.9549 17.7691 10.895C17.3129 10.3101 16.6948 9.9012 16.0023 9.71094'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.58423 8.0969L3.10905 8.39404C3.01505 8.45263 2.93811 8.5344 2.88499 8.63162L2.30229 9.69979C2.22245 9.84627 2 9.78961 2 9.62285V8.31581C2 8.00836 2.1101 7.71122 2.31002 7.47782L2.60105 7.13818'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.84882 6.81003L4.15763 6.18033C3.92036 5.964 3.61099 5.84424 3.29034 5.84424H2.86185C2.28849 5.84424 2.00101 6.538 2.40664 6.94363L2.91723 7.4539L4.25324 8.74162H7.02185'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.64011 9.38551H8.11383C7.87721 9.38551 7.64896 9.29891 7.47222 9.14181L4.84912 6.81006H6.12783C6.36188 6.81006 6.5882 6.89505 6.76429 7.04958L7.41137 7.6165C7.52888 7.71919 7.67954 7.77585 7.83568 7.77585H8.72292'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M11.2543 9.38564H9.63984L8.72266 7.77598L9.02109 7.47014C9.98753 6.47956 11.4427 6.14282 12.7462 6.60801L13.1128 6.73872L13.107 6.7561'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M11.0627 5.43604H11.7243C11.9172 5.43604 12.0997 5.52231 12.222 5.67105L13.1096 6.75113'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.22827 11.7461L9.64018 9.38574H11.2547'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.08802 11.3887L6.14653 11.9543C5.52585 12.0734 4.95538 12.376 4.50854 12.8229C4.44287 12.8889 4.41357 12.9694 4.41357 13.0479C4.41357 13.2201 4.55329 13.3846 4.75643 13.3721L9.38001 13.083'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.95171 13.2389C10.574 13.2389 11.0785 12.7344 11.0785 12.1121C11.0785 11.4898 10.574 10.9854 9.95171 10.9854C9.32942 10.9854 8.82495 11.4898 8.82495 12.1121C8.82495 12.7344 9.32942 13.2389 9.95171 13.2389Z'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.78711 13.1821L8.43902 14.3938C8.60739 14.7067 8.93415 14.9018 9.28956 14.9018H10.7537C11.208 14.9018 11.6007 14.5857 11.6973 14.1417C12.4249 10.7937 15.2128 9.80147 16.8791 9.50819C17.6682 9.36911 18.1659 8.57716 17.9447 7.8071C17.7792 7.23213 17.5442 6.79527 17.3369 6.48782L15.3232 6.32171C15.1207 6.30497 14.9253 6.24058 14.7527 6.13402L12.966 5.03076L13.1849 5.91124C13.276 6.27728 13.202 6.66489 12.9824 6.97169L12.4773 7.67736'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M11.821 8.59424L10.1025 10.9952'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M14.8252 10.1577L15.5064 12.7003C15.5176 12.7422 15.5228 12.784 15.5228 12.8256C15.5228 13.039 15.3805 13.2341 15.1648 13.292C14.9073 13.3609 14.6423 13.208 14.5734 12.9505L13.9604 10.6622'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M17.9047 8.66909L17.325 8.52412C17.1955 8.49174 17.0793 8.41988 16.9924 8.3185L16.7164 7.99657C16.5232 7.77106 16.7123 7.42637 17.0064 7.46835L17.8783 7.59284'
                    stroke={color}
                    strokeWidth='0.6'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        </div>
    );
};

const RightArrowIcon = ({
    width = '18',
    height = '18',
    strokeColor = 'var(--clr-white)',
    color = 'var(--clr-primary-web)',
    disabled = false,
    ...props
}) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 20 21'
        fill='none'
        {...props}
    >
        <path
            d='M10 20.5C15.5229 20.5 20 16.0229 20 10.5C20 4.97716 15.5229 0.5 10 0.5C4.47716 0.5 0 4.97716 0 10.5C0 16.0229 4.47716 20.5 10 20.5Z'
            fill={disabled ? 'var(--clr-white)' : color}
        />
        <path
            d='M8.97168 7.97668L11.9623 10.9673L8.97168 13.958'
            fill={disabled ? 'var(--clr-white)' : color}
        />
        <path
            d='M8.97168 7.97668L11.9623 10.9673L8.97168 13.958'
            stroke={disabled ? 'var(--disable-2)' : strokeColor}
            strokeWidth='1.49533'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

const SearchIcon = ({
    width = '18',
    height = '18',
    disabled = false,
    className,
    ...props
}) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 23 23'
        fill='none'
        className={cn('fill-white', className)}
        {...props}
    >
        <g clipPath='url(#clip0_1_440)'>
            <path d='M2.01465 3.91364C2.24967 3.58507 2.50973 3.27333 2.79395 2.97998C2.50973 3.27333 2.24962 3.58501 2.01465 3.91364Z' />
            <path d='M21.9632 19.9789L15.3139 13.3296C15.6454 12.8586 15.9259 12.3534 16.1524 11.8179C16.5775 10.8127 16.7931 9.74561 16.7931 8.64648C16.7931 7.54736 16.5775 6.48031 16.1524 5.47506C15.742 4.50481 15.1548 3.63372 14.4071 2.88606C13.6594 2.1384 12.7883 1.5512 11.8181 1.1408C10.8128 0.715599 9.74574 0.5 8.64662 0.5C7.54749 0.5 6.48045 0.715599 5.4752 1.1408C4.50495 1.5512 3.63386 2.1384 2.8862 2.88606C2.85522 2.91704 2.82462 2.9483 2.79419 2.97972L4.83088 5.01641C4.82945 5.01789 4.82807 5.01938 4.82664 5.02092C4.85817 4.98774 4.89009 4.95489 4.92255 4.92247C5.40669 4.43834 5.97006 4.05837 6.59705 3.79319C7.24539 3.51894 7.935 3.37994 8.64656 3.37994C9.35813 3.37994 10.0477 3.51899 10.6961 3.79319C11.3231 4.05837 11.8864 4.43834 12.3706 4.92247C12.8547 5.40661 13.2346 5.96998 13.4998 6.59697C13.7741 7.24531 13.9131 7.93492 13.9131 8.64648C13.9131 9.35805 13.774 10.0477 13.4998 10.696C13.2347 11.323 12.8548 11.8864 12.3706 12.3705C12.3396 12.4015 12.3082 12.4321 12.2766 12.4622L21.8124 21.998L21.7052 22.1052L21.9632 21.8472C22.4791 21.3313 22.4791 20.4947 21.9632 19.9788L21.9632 19.9789Z' />
            <path d='M3.81763 6.54016C3.80938 6.55904 3.80124 6.57796 3.7932 6.597C3.59075 7.07569 3.46193 7.57683 3.40845 8.09272C3.46199 7.57683 3.59075 7.07569 3.7932 6.59706C3.80124 6.57808 3.80938 6.55915 3.81763 6.54022V6.54016Z' />
            <path d='M11.818 16.1522C10.8128 16.5774 9.74571 16.793 8.64659 16.793C7.54746 16.793 6.48042 16.5774 5.47517 16.1522C4.50492 15.7418 3.63383 15.1546 2.88617 14.4069C2.13845 13.6592 1.5513 12.7881 1.1409 11.8179C1.5513 12.7881 2.13845 13.6592 2.88617 14.4069C3.63388 15.1546 4.50492 15.7418 5.47517 16.1522C6.48042 16.5774 7.54746 16.793 8.64659 16.793C9.74571 16.793 10.8128 16.5774 11.818 16.1522C12.29 15.9525 12.7386 15.7109 13.1608 15.4294C12.7385 15.7108 12.29 15.9525 11.818 16.1522Z' />
            <path
                opacity='0.2'
                d='M3.40845 9.20032C3.46199 9.7162 3.59075 10.2173 3.7932 10.696C3.8835 10.9095 3.98712 11.1157 4.10367 11.3138C3.98717 11.1157 3.8835 10.9095 3.7932 10.696C3.59075 10.2173 3.46193 9.7162 3.40845 9.20037V9.20032Z'
            />
            <path
                opacity='0.2'
                d='M8.64657 13.913C7.93495 13.913 7.2454 13.7739 6.59706 13.4997C6.31086 13.3787 6.03798 13.2337 5.77979 13.0658C6.03798 13.2336 6.31086 13.3787 6.59706 13.4997C7.2454 13.774 7.935 13.913 8.64657 13.913C9.35813 13.913 10.0477 13.7739 10.6961 13.4997C10.0477 13.774 9.35813 13.913 8.64657 13.913Z'
            />
            <path d='M12.2766 12.4622C12.2512 12.4863 12.2255 12.5102 12.1997 12.5338C12.1959 12.5373 12.1922 12.5407 12.1885 12.5442C12.179 12.5528 12.1695 12.5613 12.16 12.5699C12.1542 12.5751 12.1484 12.5803 12.1426 12.5855C12.1336 12.5935 12.1245 12.6014 12.1155 12.6094C12.1091 12.615 12.1027 12.6206 12.0963 12.6261C12.0875 12.6338 12.0787 12.6414 12.0698 12.649C12.0631 12.6548 12.0564 12.6605 12.0496 12.6663C12.0409 12.6737 12.0321 12.681 12.0233 12.6884C12.0164 12.6942 12.0094 12.7 12.0025 12.7058C11.9938 12.713 11.985 12.7202 11.9763 12.7274C11.9692 12.7332 11.9621 12.739 11.9549 12.7448C11.9462 12.7518 11.9375 12.7589 11.9287 12.7659C11.9215 12.7716 11.9143 12.7774 11.907 12.7831C11.8982 12.7901 11.8895 12.7969 11.8807 12.8038C11.8733 12.8095 11.8659 12.8152 11.8586 12.8209C11.8498 12.8277 11.841 12.8344 11.8323 12.8411C11.8248 12.8468 11.8173 12.8525 11.8098 12.8581C11.801 12.8647 11.7922 12.8714 11.7834 12.8779C11.7758 12.8836 11.7682 12.8892 11.7606 12.8948C11.7518 12.9013 11.743 12.9077 11.7341 12.9142C11.7264 12.9198 11.7186 12.9253 11.7109 12.9309C11.7021 12.9372 11.6933 12.9435 11.6845 12.9498C11.6766 12.9553 11.6687 12.9608 11.6608 12.9664C11.652 12.9725 11.6432 12.9787 11.6343 12.9848C11.6263 12.9904 11.6182 12.9958 11.6101 13.0013C11.6014 13.0073 11.5926 13.0133 11.5838 13.0193C11.5754 13.0249 11.567 13.0305 11.5586 13.0361C11.5455 13.0448 11.5323 13.0535 11.5192 13.0621C11.5071 13.0699 11.4951 13.0778 11.483 13.0855C11.475 13.0906 11.4669 13.0957 11.4588 13.1008C11.4496 13.1066 11.4404 13.1125 11.4312 13.1183C11.4229 13.1234 11.4145 13.1285 11.4062 13.1337C11.3971 13.1393 11.388 13.1449 11.3789 13.1504C11.3705 13.1555 11.362 13.1606 11.3536 13.1656C11.3445 13.1711 11.3354 13.1765 11.3263 13.1819C11.3178 13.1869 11.3093 13.1919 11.3007 13.1969C11.2916 13.2022 11.2824 13.2076 11.2732 13.2129C11.2647 13.2178 11.2562 13.2226 11.2476 13.2275C11.2383 13.2328 11.229 13.2381 11.2197 13.2433C11.2112 13.2481 11.2027 13.2528 11.1941 13.2575C11.1847 13.2627 11.1753 13.2679 11.1659 13.273C11.1573 13.2777 11.1488 13.2823 11.1402 13.2869C11.1307 13.292 11.1211 13.2971 11.1116 13.3022C11.103 13.3067 11.0944 13.3112 11.0859 13.3157C11.0762 13.3208 11.0665 13.3257 11.0569 13.3307C11.0484 13.3351 11.0399 13.3395 11.0313 13.3438C11.0214 13.3488 11.0116 13.3538 11.0017 13.3587C10.9933 13.3629 10.9848 13.3671 10.9763 13.3713C10.9662 13.3763 10.9561 13.3812 10.946 13.3861C10.9377 13.3901 10.9293 13.3942 10.921 13.3982C10.9105 13.4032 10.9001 13.4081 10.8896 13.4131C10.8815 13.4169 10.8735 13.4207 10.8653 13.4245C10.8543 13.4297 10.8432 13.4347 10.8322 13.4397C10.8246 13.4432 10.8169 13.4468 10.8093 13.4502C10.797 13.4557 10.7846 13.4612 10.7723 13.4666C10.7658 13.4695 10.7594 13.4724 10.7529 13.4752C10.7345 13.4833 10.7161 13.4912 10.6976 13.499C10.6971 13.4992 10.6967 13.4994 10.6962 13.4997C10.0478 13.7739 9.35821 13.9129 8.64665 13.9129C7.93508 13.9129 7.24547 13.7739 6.59714 13.4997C6.31094 13.3786 6.03805 13.2336 5.77986 13.0657C5.76115 13.0535 5.7425 13.0413 5.72395 13.0288C5.6593 12.9856 5.59552 12.9409 5.53279 12.8947C5.51028 12.8782 5.48788 12.8614 5.46565 12.8445C5.45536 12.8367 5.44513 12.8289 5.43489 12.821C5.35736 12.7612 5.28137 12.6991 5.20697 12.6348C5.18881 12.6192 5.17076 12.6033 5.15277 12.5873C5.07419 12.5175 4.99748 12.4452 4.92264 12.3704C4.82931 12.277 4.73989 12.1807 4.65438 12.0816C4.55368 11.9649 4.45842 11.8443 4.36878 11.7199C4.34886 11.6923 4.32922 11.6644 4.30985 11.6364C4.30016 11.6224 4.29053 11.6083 4.28102 11.5943C4.26192 11.5661 4.2431 11.5377 4.22461 11.5091C4.1829 11.4449 4.14268 11.3797 4.10383 11.3137C3.98733 11.1155 3.88366 10.9094 3.79336 10.6959C3.59091 10.2172 3.46209 9.71605 3.4086 9.20017C3.3987 9.10464 3.39138 9.00861 3.38659 8.91209C3.38225 8.82388 3.3801 8.73529 3.3801 8.64631C3.3801 8.55733 3.38225 8.46874 3.38659 8.38053C3.39133 8.28401 3.3987 8.18798 3.4086 8.09246C3.46215 7.57657 3.59091 7.07543 3.79336 6.59674C3.80139 6.57776 3.80954 6.55883 3.81779 6.5399C3.82043 6.53379 3.82318 6.52774 3.82588 6.52163C3.83149 6.50887 3.83711 6.49615 3.84283 6.48344C3.84613 6.47607 3.84954 6.46875 3.85284 6.46143C3.85802 6.45004 3.86319 6.43871 3.86847 6.42737C3.87216 6.4195 3.87585 6.41163 3.87953 6.40382C3.88459 6.39309 3.8896 6.38236 3.89472 6.37168C3.89863 6.36354 3.90259 6.35539 3.9065 6.3473C3.9115 6.33696 3.91657 6.32661 3.92163 6.31632C3.9257 6.30801 3.92983 6.29976 3.93401 6.29151C3.93907 6.28144 3.94408 6.27137 3.9492 6.26135C3.95343 6.25299 3.95773 6.24462 3.96202 6.23631C3.96714 6.22641 3.97225 6.21656 3.97737 6.20665C3.98177 6.19829 3.98618 6.18992 3.99058 6.18156C3.99575 6.17182 4.00098 6.16203 4.00621 6.15234C4.01072 6.14398 4.01523 6.13561 4.01974 6.12725C4.02503 6.11762 4.03031 6.10799 4.03565 6.09836C4.04027 6.09005 4.04489 6.08168 4.04951 6.07338C4.05485 6.0638 4.0603 6.05428 4.06569 6.04471C4.07042 6.03645 4.0751 6.02814 4.07983 6.01989C4.08534 6.01037 4.09084 6.0009 4.0964 5.99138C4.10118 5.98318 4.10597 5.97499 4.11081 5.96679C4.11643 5.95727 4.12215 5.9478 4.12787 5.93828C4.13272 5.93025 4.1375 5.92216 4.1424 5.91413C4.14823 5.9045 4.15418 5.89492 4.16006 5.88535C4.16491 5.87753 4.16969 5.86966 4.17454 5.86185C4.18081 5.85178 4.18719 5.84171 4.19358 5.83169C4.19814 5.82448 4.20271 5.81722 4.20728 5.81001C4.21806 5.79317 4.2289 5.77645 4.23985 5.75972C4.24464 5.7524 4.24954 5.74513 4.25438 5.73787C4.26082 5.72819 4.26726 5.71845 4.27375 5.70876C4.27925 5.70062 4.28481 5.69253 4.29031 5.68444C4.29626 5.67569 4.3022 5.66694 4.3082 5.65825C4.31398 5.64988 4.31986 5.64152 4.3257 5.63321C4.33153 5.62484 4.33736 5.61648 4.34331 5.60812C4.3493 5.59964 4.35536 5.59122 4.36141 5.58275C4.36724 5.5746 4.37308 5.56646 4.37891 5.55837C4.38507 5.54984 4.39135 5.54137 4.39762 5.53284C4.40345 5.52491 4.40928 5.51693 4.41517 5.50907C4.4215 5.50054 4.42794 5.49201 4.43432 5.48353C4.44021 5.47572 4.4461 5.46796 4.45199 5.46015C4.45848 5.45162 4.46503 5.44314 4.47152 5.43467C4.47746 5.42696 4.48341 5.41932 4.48935 5.41167C4.49601 5.40314 4.50267 5.39466 4.50933 5.38624C4.51532 5.3787 4.52132 5.37117 4.52732 5.36363C4.53409 5.35515 4.54086 5.34668 4.54774 5.33826C4.55373 5.33083 4.55984 5.3234 4.56589 5.31603C4.57283 5.30755 4.57976 5.29908 4.58675 5.29066C4.5928 5.2834 4.59886 5.27613 4.60491 5.26892C4.61201 5.26045 4.61911 5.25198 4.62631 5.2435C4.63237 5.2364 4.63842 5.2293 4.64453 5.22221C4.65179 5.21373 4.65911 5.2052 4.66643 5.19673C4.67243 5.18985 4.67848 5.18297 4.68453 5.17609C4.69207 5.16751 4.69956 5.15892 4.70715 5.15039C4.71293 5.1439 4.71876 5.13746 4.72459 5.13097C4.73252 5.12211 4.74044 5.11325 4.74842 5.1045C4.75315 5.09927 4.75794 5.09416 4.76273 5.08898C4.78375 5.06604 4.80499 5.04326 4.82645 5.02069C4.82788 5.01921 4.82926 5.01772 4.83069 5.01618L2.794 2.97949C2.794 2.97949 2.79389 2.97966 2.79378 2.97971C2.50956 3.27307 2.2495 3.58474 2.01448 3.91337C2.01277 3.91579 2.01101 3.91821 2.00925 3.92063C1.99384 3.9422 1.9786 3.96394 1.96341 3.98568C1.96027 3.99019 1.95708 3.99465 1.95394 3.99916C1.93986 4.01941 1.92588 4.03977 1.91196 4.06018C1.90783 4.06624 1.90365 4.07229 1.89952 4.0784C1.88648 4.09766 1.87355 4.11697 1.86062 4.13634C1.85577 4.14366 1.85088 4.15098 1.84604 4.1583C1.83382 4.17673 1.82177 4.19528 1.80972 4.21382C1.80432 4.22213 1.79888 4.23049 1.79348 4.23886C1.78198 4.25669 1.77065 4.27457 1.75931 4.29246C1.75348 4.30165 1.7477 4.31084 1.74187 4.32008C1.73103 4.33736 1.72024 4.35469 1.70957 4.37208C1.70346 4.38204 1.69729 4.39195 1.69124 4.40191C1.68095 4.41874 1.67072 4.43564 1.66054 4.45259C1.65415 4.46321 1.64782 4.47383 1.6415 4.48445C1.6317 4.5009 1.62202 4.51735 1.61233 4.53386C1.60573 4.54509 1.59918 4.55637 1.59269 4.5677C1.58339 4.58377 1.57414 4.59984 1.56495 4.61596C1.55818 4.62785 1.55147 4.63974 1.54481 4.65162C1.53601 4.66731 1.52715 4.68304 1.51845 4.69878C1.51158 4.71122 1.50475 4.72371 1.49793 4.7362C1.48951 4.75155 1.48115 4.76691 1.47284 4.78231C1.46585 4.79535 1.45886 4.8084 1.45193 4.82149C1.44395 4.83652 1.43597 4.85154 1.42804 4.86662C1.42089 4.88021 1.41385 4.89391 1.4068 4.90756C1.39926 4.92219 1.39167 4.93683 1.38419 4.95152C1.37692 4.96578 1.36977 4.98014 1.36262 4.99445C1.35546 5.0087 1.34831 5.02289 1.34126 5.0372C1.33389 5.05217 1.32663 5.06719 1.31931 5.08216C1.3126 5.09592 1.30588 5.10967 1.29928 5.12343C1.29168 5.13928 1.2842 5.15518 1.27672 5.17114C1.27055 5.18424 1.26434 5.19728 1.25823 5.21037C1.25025 5.22749 1.24249 5.24466 1.23462 5.26183C1.22912 5.27388 1.22356 5.28587 1.21811 5.29792C1.20925 5.31751 1.20061 5.33721 1.19192 5.35686C1.18763 5.3666 1.18323 5.37634 1.17899 5.38608C1.16611 5.41563 1.15335 5.44523 1.14074 5.47495C1.13409 5.49063 1.12748 5.50637 1.12099 5.52211C1.11037 5.54769 1.09986 5.57328 1.08951 5.59893C0.830552 6.24022 0.656114 6.90589 0.567794 7.5884C0.546609 7.75222 0.530375 7.91697 0.519095 8.08261C0.514472 8.15057 0.510675 8.21863 0.507759 8.28687C0.506273 8.32099 0.505008 8.35516 0.503962 8.38933C0.502916 8.4235 0.502091 8.45773 0.501431 8.49201C0.500495 8.54341 0.5 8.59486 0.5 8.64637C0.5 8.87682 0.50952 9.10585 0.528394 9.33317C0.529935 9.3516 0.531531 9.36998 0.533182 9.38836C0.555083 9.63191 0.587824 9.87349 0.631296 10.1127C0.631847 10.1157 0.632342 10.1186 0.632892 10.1215C0.638615 10.1529 0.644558 10.1843 0.650666 10.2156C0.650831 10.2164 0.650941 10.2171 0.651106 10.2179C0.737005 10.6572 0.859387 11.0885 1.01781 11.5097C1.02359 11.525 1.02937 11.5404 1.03526 11.5557C1.05055 11.5957 1.06618 11.6356 1.08214 11.6754C1.08219 11.6756 1.0823 11.6758 1.08236 11.676C1.10134 11.7234 1.12082 11.7706 1.14074 11.8177C1.55114 12.788 2.13829 13.6591 2.88601 14.4067C3.63372 15.1544 4.50476 15.7416 5.47501 16.152C6.48026 16.5772 7.5473 16.7928 8.64643 16.7928C9.74555 16.7928 10.8126 16.5772 11.8178 16.152C12.2899 15.9524 12.7384 15.7107 13.1607 15.4292L19.8366 22.1051C20.3525 22.6211 21.1891 22.6211 21.705 22.1051L21.8123 21.9979L12.2764 12.462L12.2766 12.4622Z' />
        </g>
        <defs>
            <clipPath id='clip0_1_440'>
                <rect width='21.85' height='21.9923' transform='translate(0.5 0.5)' />
            </clipPath>
        </defs>
    </svg>
);

const StarIcon = ({ className = '', fill = 'var(--clr-white)' }) => (
    <svg
        width='15'
        height='15'
        viewBox='0 0 15 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g clipPath='url(#clip0_939_740)'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.66666 1.18018C7.46823 1.18018 7.27394 1.23694 7.10673 1.34378C6.94165 1.44925 6.80976 1.59917 6.72618 1.77622L5.13862 4.98131C5.1355 4.98761 5.13251 4.99397 5.12966 5.0004C5.12895 5.00199 5.12783 5.00338 5.12642 5.00441C5.12501 5.00544 5.12336 5.00609 5.12162 5.00628C5.11553 5.00695 5.10945 5.00774 5.10339 5.00864L1.60781 5.5265C1.4146 5.54529 1.23036 5.61779 1.07605 5.73599C0.916375 5.8583 0.795593 6.02428 0.728332 6.21383C0.661072 6.40338 0.650219 6.60837 0.697088 6.80397C0.743776 6.9988 0.845745 7.17599 0.990711 7.31424L3.54949 9.78306L3.55532 9.78859C3.55897 9.79201 3.56172 9.79628 3.5633 9.80103C3.56488 9.80577 3.56525 9.81084 3.56437 9.81576L3.56381 9.81903L2.95407 13.3874C2.92057 13.5808 2.94178 13.7806 3.01559 13.9624C3.0895 14.1446 3.21306 14.3023 3.37219 14.4177C3.53133 14.533 3.71965 14.6014 3.91573 14.615C4.11142 14.6286 4.307 14.5871 4.4803 14.4953L4.48135 14.4947L7.63083 12.8302C7.64212 12.8253 7.65433 12.8227 7.66668 12.8227C7.67903 12.8227 7.69123 12.8253 7.70253 12.8302L10.852 14.4947C11.0254 14.5868 11.2218 14.6287 11.4176 14.615C11.6137 14.6014 11.802 14.533 11.9612 14.4177C12.1203 14.3023 12.2439 14.1446 12.3178 13.9624C12.3916 13.7806 12.4129 13.5818 12.3795 13.3885L12.3793 13.3874L11.7696 9.81902L11.769 9.81576C11.7681 9.81084 11.7685 9.80577 11.7701 9.80103C11.7716 9.79629 11.7744 9.79201 11.778 9.78859L11.7839 9.78306L14.3427 7.31421C14.4876 7.17596 14.5896 6.99879 14.6363 6.80397C14.6831 6.60837 14.6723 6.40338 14.605 6.21383C14.5378 6.02428 14.417 5.8583 14.2573 5.73599C14.103 5.61779 13.9188 5.54529 13.7256 5.5265L10.2299 5.00864C10.2239 5.00774 10.2178 5.00695 10.2117 5.00628C10.21 5.00609 10.2083 5.00544 10.2069 5.00441C10.2055 5.00338 10.2044 5.00199 10.2037 5.0004C10.2008 4.99397 10.1978 4.98761 10.1947 4.98131L8.60714 1.77621C8.52356 1.59916 8.39167 1.44925 8.2266 1.34378C8.05938 1.23694 7.86509 1.18018 7.66666 1.18018Z'
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id='clip0_939_740'>
                <rect
                    width='14'
                    height='14'
                    fill='white'
                    transform='translate(0.666687 0.90332)'
                />
            </clipPath>
        </defs>
    </svg>
    // </div>
);

const FlagLocation = ({ color = 'var(--clr-primary-web)', className = '' }) => {
    return (
        <div className={className}>
            <svg
                width='15'
                height='16'
                viewBox='0 0 15 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clipPath='url(#clip0_861_2387)'>
                    <path
                        d='M2.67859 1.03571V14.9643'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M2.67859 1.03571L12.3214 5.85713L2.67859 10.6786'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_861_2387'>
                        <rect
                            width='15'
                            height='15'
                            fill='white'
                            transform='translate(0 0.5)'
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};
const PinLocation = ({ color = 'var(--clr-primary-web)', className = '' }) => {
    return (
        <div className={className}>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='15'
                height='16'
                viewBox='0 0 15 16'
                fill='none'
            >
                <g clipPath='url(#clip0_861_2403)'>
                    <path
                        d='M12.3215 5.85713C12.3215 9.07142 7.50008 12.8214 7.50008 12.8214C7.50008 12.8214 2.67865 9.07142 2.67865 5.85713C2.67865 3.23106 4.87401 1.03571 7.50008 1.03571C10.1262 1.03571 12.3215 3.23106 12.3215 5.85713Z'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.50009 7.46429C8.38769 7.46429 9.10723 6.74475 9.10723 5.85714C9.10723 4.96954 8.38769 4.25 7.50009 4.25C6.61248 4.25 5.89294 4.96954 5.89294 5.85714C5.89294 6.74475 6.61248 7.46429 7.50009 7.46429Z'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.8686 11.2143H12.8572L14.4643 14.9643H0.535767L2.14291 11.2143H3.13152'
                        stroke={color}
                        strokeWidth='1.07143'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_861_2403'>
                        <rect
                            width='15'
                            height='15'
                            fill='white'
                            transform='translate(0 0.5)'
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

// //#region Search current location
const SearchIconCurrent = ({
    color = 'var(--clr-primary-web)',
    className = ''
}) => {
    return (
        <div className={className}>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='15'
                height='16'
                viewBox='0 0 15 16'
                fill='none'
            >
                <g clipPath='url(#clip0_861_2576)'>
                    <path
                        d='M1.04004 2.79458C1.20138 2.56902 1.37991 2.35501 1.57503 2.15363C1.37991 2.35501 1.20134 2.56898 1.04004 2.79458Z'
                        fill='white'
                    />
                    <path
                        d='M14.7345 13.8234L10.1698 9.25865C10.3973 8.93532 10.5898 8.5885 10.7453 8.2209C11.0372 7.53079 11.1852 6.79827 11.1852 6.04372C11.1852 5.28917 11.0372 4.55665 10.7453 3.86655C10.4636 3.20047 10.0605 2.60247 9.54719 2.0892C9.03389 1.57593 8.43592 1.17282 7.76985 0.891079C7.07971 0.59918 6.34718 0.451172 5.59263 0.451172C4.83809 0.451172 4.10556 0.59918 3.41546 0.891079C2.74939 1.17282 2.15138 1.57593 1.63811 2.0892C1.61685 2.11047 1.59584 2.13192 1.57495 2.1535L2.97314 3.55168C2.97215 3.5527 2.97121 3.55372 2.97023 3.55478C2.99187 3.532 3.01378 3.50945 3.03607 3.4872C3.36843 3.15484 3.75518 2.89399 4.18561 2.71195C4.63069 2.52367 5.10411 2.42824 5.5926 2.42824C6.08109 2.42824 6.5545 2.52371 6.99958 2.71195C7.43001 2.89399 7.81676 3.15484 8.14912 3.4872C8.48148 3.81955 8.74229 4.20631 8.92437 4.63673C9.11265 5.08182 9.20807 5.55523 9.20807 6.04372C9.20807 6.53221 9.11261 7.00562 8.92437 7.45071C8.74233 7.88113 8.48152 8.26789 8.14912 8.60025C8.12785 8.62152 8.10632 8.64252 8.0846 8.66318L14.6309 15.2095L14.5573 15.2831L14.7344 15.106C15.0886 14.7518 15.0886 14.1775 14.7344 13.8233L14.7345 13.8234Z'
                        fill={color}
                    />
                    <path
                        d='M2.27798 4.59766C2.27231 4.61061 2.26672 4.62361 2.2612 4.63668C2.12222 4.9653 2.03379 5.30933 1.99707 5.66348C2.03383 5.30933 2.12222 4.9653 2.2612 4.63672C2.26672 4.62368 2.27231 4.61069 2.27798 4.59769V4.59766Z'
                        fill='white'
                    />
                    <path
                        d='M7.77004 11.1963C7.07994 11.4882 6.34742 11.6362 5.59287 11.6362C4.83832 11.6362 4.1058 11.4882 3.41569 11.1963C2.74962 10.9146 2.15162 10.5115 1.63835 9.99819C1.12504 9.48493 0.721965 8.88692 0.440227 8.22085C0.721965 8.88692 1.12504 9.48489 1.63835 9.99819C2.15165 10.5115 2.74962 10.9146 3.41569 11.1963C4.1058 11.4882 4.83832 11.6362 5.59287 11.6362C6.34742 11.6362 7.07994 11.4882 7.77004 11.1963C8.09409 11.0593 8.40201 10.8934 8.6919 10.7001C8.40197 10.8933 8.09409 11.0593 7.77004 11.1963Z'
                        fill='white'
                    />
                    <path
                        opacity='0.2'
                        d='M1.99707 6.42389C2.03383 6.77804 2.12222 7.12208 2.2612 7.45069C2.32319 7.59727 2.39433 7.73878 2.47434 7.87481C2.39437 7.73878 2.32319 7.59727 2.2612 7.45069C2.12222 7.12208 2.03379 6.77804 1.99707 6.42393V6.42389Z'
                        fill='white'
                    />
                    <path
                        opacity='0.2'
                        d='M5.5928 9.65918C5.10427 9.65918 4.6309 9.56372 4.18581 9.37548C3.98934 9.29237 3.802 9.19283 3.62476 9.07758C3.802 9.19279 3.98934 9.29237 4.18581 9.37548C4.6309 9.56376 5.10431 9.65918 5.5928 9.65918C6.08129 9.65918 6.5547 9.56372 6.99979 9.37548C6.5547 9.56376 6.08129 9.65918 5.5928 9.65918Z'
                        fill='white'
                    />
                    <path
                        d='M8.08484 8.66322C8.06742 8.6798 8.04982 8.6962 8.0321 8.71241C8.02949 8.71479 8.02692 8.71717 8.02435 8.71955C8.01786 8.72548 8.01132 8.73129 8.00479 8.73719C8.00082 8.74074 7.99685 8.74433 7.99289 8.74788C7.98669 8.75339 7.98046 8.75883 7.97426 8.76427C7.96988 8.76813 7.9655 8.77198 7.96112 8.77579C7.95507 8.78105 7.94899 8.78626 7.94291 8.79147C7.9383 8.79544 7.93369 8.79941 7.92905 8.80333C7.92304 8.80843 7.91703 8.81346 7.91099 8.81852C7.90623 8.82252 7.90147 8.82653 7.89667 8.8305C7.8907 8.83544 7.8847 8.84039 7.87869 8.8453C7.87382 8.84931 7.86894 8.85327 7.86403 8.85724C7.85806 8.86208 7.85206 8.86691 7.84605 8.87171C7.8411 8.87568 7.83611 8.87964 7.83113 8.88357C7.82512 8.88833 7.81911 8.89305 7.81307 8.89774C7.80801 8.90167 7.80295 8.9056 7.79788 8.90952C7.79188 8.91417 7.78583 8.91878 7.77983 8.92339C7.77469 8.92728 7.76955 8.93117 7.76441 8.93506C7.75837 8.93959 7.75233 8.94416 7.74628 8.94866C7.74107 8.95251 7.73586 8.95637 7.73064 8.96022C7.7246 8.96468 7.71855 8.9691 7.71247 8.97352C7.70715 8.97737 7.70182 8.98119 7.69649 8.985C7.69045 8.98935 7.6844 8.99369 7.67836 8.99796C7.67296 9.00177 7.66752 9.00555 7.66212 9.00937C7.65607 9.0136 7.65003 9.01783 7.64395 9.02202C7.63843 9.02584 7.63288 9.02958 7.62732 9.03336C7.62132 9.03747 7.61531 9.04159 7.60927 9.04567C7.60352 9.04956 7.59771 9.05338 7.59193 9.05723C7.58294 9.0632 7.57391 9.06917 7.56488 9.07506C7.55661 9.08046 7.54837 9.08583 7.54006 9.09115C7.53454 9.09467 7.52899 9.09814 7.52348 9.10165C7.51713 9.10566 7.51082 9.1097 7.50447 9.11363C7.49877 9.11718 7.49307 9.1207 7.48732 9.12421C7.48109 9.12806 7.47486 9.13191 7.46862 9.13569C7.46284 9.1392 7.45703 9.14268 7.45121 9.14616C7.44498 9.1499 7.43874 9.15364 7.43247 9.15734C7.42665 9.16077 7.4208 9.16418 7.41494 9.16761C7.40867 9.17128 7.40236 9.17494 7.39606 9.17861C7.3902 9.18197 7.38435 9.18529 7.37845 9.18865C7.37207 9.19228 7.36572 9.19591 7.35934 9.19946C7.35348 9.20275 7.34763 9.20599 7.34173 9.20924C7.33527 9.21279 7.32881 9.21638 7.32235 9.2199C7.3165 9.22311 7.31061 9.22628 7.30471 9.22942C7.29818 9.23293 7.29164 9.2364 7.28511 9.23988C7.27921 9.24301 7.27332 9.24611 7.26743 9.24917C7.26082 9.25265 7.25417 9.25605 7.24756 9.25949C7.2417 9.26251 7.23585 9.26549 7.22995 9.26848C7.22319 9.27191 7.21643 9.27531 7.20967 9.27868C7.20385 9.28158 7.19803 9.28449 7.19221 9.28736C7.1853 9.29076 7.17835 9.29416 7.1714 9.29753C7.16569 9.30028 7.15995 9.30308 7.15425 9.30584C7.14707 9.30927 7.13989 9.31264 7.13272 9.31604C7.12716 9.31864 7.12161 9.32129 7.11602 9.32389C7.10846 9.32741 7.10087 9.33085 7.09331 9.33432C7.08806 9.3367 7.08281 9.33916 7.07756 9.3415C7.06914 9.34531 7.06064 9.34905 7.05218 9.35279C7.04772 9.35476 7.0433 9.35676 7.03884 9.35869C7.02622 9.3642 7.01361 9.36964 7.00091 9.37501C7.00057 9.37516 7.00023 9.37531 6.99989 9.37546C6.55481 9.56374 6.0814 9.65916 5.59291 9.65916C5.10442 9.65916 4.631 9.5637 4.18592 9.37546C3.98944 9.29235 3.80211 9.19281 3.62486 9.07755C3.61202 9.06921 3.59921 9.06078 3.58648 9.05224C3.5421 9.02255 3.49831 8.99188 3.45525 8.96018C3.4398 8.94881 3.42442 8.93733 3.40916 8.92573C3.4021 8.92037 3.39507 8.915 3.38804 8.90956C3.33482 8.8685 3.28265 8.82589 3.23157 8.78176C3.21911 8.771 3.20672 8.76012 3.19436 8.74916C3.14042 8.70122 3.08776 8.65159 3.03638 8.60021C2.97231 8.53614 2.91093 8.47003 2.85222 8.402C2.78309 8.32187 2.7177 8.23903 2.65616 8.15365C2.64249 8.13469 2.629 8.11557 2.6157 8.09635C2.60905 8.08675 2.60244 8.07708 2.59591 8.06741C2.5828 8.04807 2.56988 8.02858 2.55719 8.00897C2.52855 7.96485 2.50094 7.92012 2.47427 7.87479C2.39429 7.73875 2.32312 7.59724 2.26113 7.45067C2.12215 7.12205 2.03372 6.77802 1.997 6.42387C1.9902 6.35829 1.98517 6.29237 1.98189 6.22611C1.9789 6.16555 1.97743 6.10473 1.97743 6.04365C1.97743 5.98256 1.9789 5.92174 1.98189 5.86118C1.98514 5.79492 1.9902 5.729 1.997 5.66342C2.03375 5.30927 2.12215 4.96524 2.26113 4.63662C2.26665 4.62359 2.27224 4.61059 2.2779 4.5976C2.27972 4.5934 2.28161 4.58925 2.28346 4.58506C2.28731 4.57629 2.29116 4.56757 2.29509 4.55884C2.29736 4.55378 2.2997 4.54875 2.30197 4.54373C2.30552 4.53591 2.30907 4.52813 2.3127 4.52035C2.31523 4.51494 2.31776 4.50954 2.32029 4.50418C2.32376 4.49681 2.3272 4.48944 2.33072 4.48212C2.3334 4.47652 2.33612 4.47093 2.3388 4.46538C2.34224 4.45828 2.34571 4.45118 2.34919 4.44411C2.35198 4.43841 2.35482 4.43274 2.35769 4.42707C2.36116 4.42016 2.3646 4.41325 2.36811 4.40637C2.37102 4.40063 2.37397 4.39489 2.37692 4.38918C2.38043 4.38239 2.38394 4.37562 2.38746 4.36882C2.39048 4.36308 2.3935 4.35734 2.39652 4.3516C2.40007 4.34491 2.40366 4.33819 2.40725 4.33154C2.41035 4.3258 2.41345 4.32005 2.41654 4.31431C2.42017 4.3077 2.4238 4.30109 2.42746 4.29448C2.43063 4.28877 2.43381 4.28303 2.43698 4.27733C2.44065 4.27076 2.44439 4.26422 2.44809 4.25765C2.45134 4.25198 2.45455 4.24628 2.4578 4.24061C2.46157 4.23407 2.46535 4.22758 2.46917 4.22104C2.47245 4.21541 2.47574 4.20978 2.47906 4.20416C2.48292 4.19762 2.48685 4.19112 2.49077 4.18459C2.4941 4.17907 2.49739 4.17352 2.50075 4.168C2.50475 4.16139 2.50883 4.15482 2.51287 4.14825C2.5162 4.14288 2.51948 4.13748 2.52281 4.13212C2.52712 4.1252 2.5315 4.11829 2.53588 4.11141C2.53902 4.10647 2.54215 4.10148 2.54529 4.09653C2.55269 4.08497 2.56013 4.07349 2.56765 4.062C2.57094 4.05698 2.5743 4.05199 2.57762 4.04701C2.58204 4.04036 2.58646 4.03367 2.59092 4.02702C2.5947 4.02143 2.59851 4.01588 2.60229 4.01032C2.60637 4.00432 2.61045 3.99831 2.61457 3.99234C2.61853 3.9866 2.62258 3.98086 2.62658 3.97515C2.63059 3.96941 2.63459 3.96367 2.63867 3.95793C2.64279 3.95211 2.64694 3.94633 2.6511 3.94051C2.6551 3.93492 2.65911 3.92933 2.66311 3.92378C2.66734 3.91792 2.67165 3.91211 2.67596 3.90625C2.67996 3.90081 2.68396 3.89533 2.68801 3.88993C2.69235 3.88408 2.69677 3.87822 2.70115 3.8724C2.70519 3.86704 2.70924 3.86171 2.71328 3.85635C2.71774 3.85049 2.72223 3.84467 2.72669 3.83886C2.73077 3.83357 2.73485 3.82832 2.73893 3.82307C2.7435 3.81721 2.74807 3.81139 2.75264 3.80561C2.75676 3.80044 2.76088 3.79526 2.76499 3.79009C2.76964 3.78427 2.77429 3.77845 2.77901 3.77267C2.78313 3.76757 2.78732 3.76247 2.79148 3.75741C2.79624 3.75159 2.801 3.74578 2.80579 3.74C2.80995 3.73501 2.8141 3.73002 2.81826 3.72507C2.82313 3.71926 2.82801 3.71344 2.83295 3.70762C2.83711 3.70275 2.84126 3.69787 2.84546 3.693C2.85044 3.68718 2.85547 3.68133 2.86049 3.67551C2.86461 3.67079 2.86877 3.66607 2.87292 3.66134C2.8781 3.65545 2.88323 3.64956 2.88845 3.6437C2.89241 3.63925 2.89642 3.63483 2.90042 3.63037C2.90586 3.62429 2.9113 3.6182 2.91678 3.6122C2.92003 3.60861 2.92332 3.6051 2.9266 3.60154C2.94103 3.58579 2.95561 3.57015 2.97035 3.55466C2.97133 3.55364 2.97227 3.55262 2.97326 3.55157L1.57507 2.15338C1.57507 2.15338 1.575 2.15349 1.57492 2.15353C1.3798 2.35492 1.20127 2.56889 1.03993 2.79449C1.03876 2.79615 1.03755 2.79781 1.03634 2.79947C1.02576 2.81428 1.0153 2.8292 1.00487 2.84413C1.00272 2.84722 1.00053 2.85028 0.998375 2.85338C0.988705 2.86728 0.979109 2.88126 0.969552 2.89527C0.966719 2.89943 0.963848 2.90359 0.961014 2.90778C0.952061 2.921 0.943184 2.93426 0.934306 2.94756C0.930982 2.95258 0.92762 2.95761 0.924296 2.96263C0.915909 2.97529 0.907636 2.98802 0.899363 3.00075C0.895661 3.00645 0.891921 3.01219 0.888219 3.01793C0.880324 3.03017 0.872542 3.04245 0.86476 3.05473C0.860755 3.06104 0.856789 3.06735 0.852785 3.07369C0.845343 3.08555 0.837938 3.09745 0.83061 3.10939C0.826417 3.11623 0.822186 3.12303 0.81803 3.12987C0.810966 3.14143 0.80394 3.15302 0.796951 3.16466C0.792569 3.17195 0.788225 3.17924 0.78388 3.18653C0.777156 3.19783 0.770507 3.20912 0.763859 3.22045C0.759326 3.22816 0.75483 3.23591 0.750372 3.24369C0.743988 3.25472 0.737642 3.26575 0.731333 3.27682C0.726687 3.28498 0.722078 3.29314 0.717507 3.3013C0.711463 3.31206 0.705381 3.32287 0.699412 3.33367C0.69469 3.34221 0.690006 3.35078 0.685321 3.35936C0.679541 3.3699 0.673799 3.38044 0.668095 3.39102C0.663298 3.39997 0.6585 3.40892 0.65374 3.41791C0.648263 3.42823 0.642785 3.43854 0.637345 3.44889C0.632434 3.45822 0.627599 3.46763 0.622763 3.477C0.617588 3.48704 0.612375 3.49709 0.607237 3.50718C0.602251 3.51696 0.59734 3.52682 0.592429 3.53664C0.587518 3.54643 0.582607 3.55617 0.577772 3.566C0.57271 3.57627 0.567723 3.58658 0.562699 3.59686C0.55809 3.6063 0.553481 3.61575 0.548948 3.62519C0.543735 3.63607 0.538597 3.64699 0.53346 3.65794C0.529229 3.66694 0.52496 3.67589 0.520767 3.68488C0.515289 3.69663 0.509963 3.70841 0.504561 3.7202C0.500783 3.72847 0.496968 3.73671 0.493228 3.74498C0.487146 3.75843 0.481215 3.77195 0.475246 3.78544C0.4723 3.79213 0.469277 3.79881 0.466369 3.8055C0.457529 3.82579 0.448765 3.84611 0.440114 3.86651C0.435543 3.87728 0.43101 3.88808 0.426552 3.89888C0.419261 3.91645 0.412046 3.93402 0.404944 3.95162C0.227168 4.39187 0.107416 4.84885 0.0467848 5.31739C0.0322409 5.42985 0.0210968 5.54296 0.0133526 5.65666C0.0101794 5.70332 0.00757279 5.75005 0.00557063 5.79689C0.00455066 5.82031 0.0036818 5.84377 0.00296405 5.86723C0.0022463 5.89069 0.00167965 5.91419 0.00122633 5.93772C0.000584129 5.973 0.000244141 6.00832 0.000244141 6.04368C0.000244141 6.20189 0.00677948 6.35912 0.0197368 6.51517C0.0207946 6.52783 0.0218901 6.54044 0.0230234 6.55306C0.0380584 6.72026 0.0605355 6.8861 0.0903789 7.05035C0.0907567 7.05235 0.0910967 7.05436 0.0914744 7.05636C0.0954032 7.07793 0.0994831 7.09946 0.103676 7.12096C0.10379 7.12149 0.103865 7.12201 0.103978 7.12254C0.162948 7.42411 0.246963 7.72021 0.355721 8.00938C0.359688 8.01989 0.363654 8.03043 0.367696 8.04093C0.378198 8.06839 0.388927 8.09578 0.399882 8.12309C0.39992 8.12324 0.399995 8.12336 0.400033 8.12351C0.413066 8.15603 0.426439 8.18848 0.440114 8.22082C0.721851 8.8869 1.12493 9.4849 1.63823 9.99817C2.15154 10.5115 2.74951 10.9145 3.41558 11.1963C4.10568 11.4882 4.83821 11.6362 5.59276 11.6362C6.3473 11.6362 7.07983 11.4882 7.76993 11.1963C8.09398 11.0592 8.40189 10.8934 8.69179 10.7001L13.2748 15.2831C13.629 15.6373 14.2033 15.6373 14.5575 15.2831L14.6311 15.2095L8.08476 8.66315L8.08484 8.66322Z'
                        fill={color}
                    />
                </g>
                <defs>
                    <clipPath id='clip0_861_2576'>
                        <rect
                            width='15'
                            height='15.0977'
                            fill='white'
                            transform='translate(0 0.451172)'
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

// #region Filter bike in location eu

export const FilterIcon = ({
    className = '',
    color = 'var(--clr-primary-web)'
}) => {
    return (
        <div className={cn(className)}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clipPath='url(#clip0_861_2437)'>
                    <path d='M8.4411 12.9744H15.4054' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M13.4155 10.9846L15.4054 12.9744L13.4155 14.9642' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M5.95417 4.02071C6.77846 4.02071 7.44667 3.35249 7.44667 2.52821C7.44667 1.70392 6.77846 1.03571 5.95417 1.03571C5.12988 1.03571 4.46167 1.70392 4.46167 2.52821C4.46167 3.35249 5.12988 4.02071 5.95417 4.02071Z' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M9.9336 8.99531C10.7579 8.99531 11.4261 8.3271 11.4261 7.50281C11.4261 6.67853 10.7579 6.01031 9.9336 6.01031C9.10932 6.01031 8.4411 6.67853 8.4411 7.50281C8.4411 8.3271 9.10932 8.99531 9.9336 8.99531Z' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M6.94874 14.4671C7.77302 14.4671 8.44124 13.7989 8.44124 12.9746C8.44124 12.1503 7.77302 11.4821 6.94874 11.4821C6.12445 11.4821 5.45624 12.1503 5.45624 12.9746C5.45624 13.7989 6.12445 14.4671 6.94874 14.4671Z' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M8.44112 7.50299H4.21279C2.70175 7.50299 1.47681 8.72793 1.47681 10.239C1.47681 11.75 2.70175 12.975 4.21279 12.975H5.45641' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M11.4257 7.50276H12.918C14.2917 7.50276 15.4052 6.38918 15.4052 5.01551C15.4052 3.64184 14.2917 2.52826 12.918 2.52826H7.44604' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M4.46152 2.52826H1.47681' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                </g>
                <defs>
                    <clipPath id='clip0_861_2437'>
                        <rect width='15' height='15' fill='white' transform='translate(0.94104 0.5)' />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export const StartRecomentIcon = ({
    className = '',
    color = 'var(--clr-primary-web)'
}) => {
    return (
        <div className={cn(className)}>
            <svg xmlns='http://www.w3.org/2000/svg' width='15' height='14' viewBox='0 0 15 14' fill='none'>
                <g clipPath='url(#clip0_1544_1701)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.94101 0.276855C7.74258 0.276855 7.54829 0.333623 7.38108 0.440458C7.216 0.545928 7.08411 0.695846 7.00053 0.872901L5.41297 4.07799C5.40985 4.08429 5.40686 4.09065 5.40401 4.09708C5.4033 4.09867 5.40218 4.10006 5.40077 4.10109C5.39936 4.10212 5.39771 4.10277 5.39597 4.10296C5.38988 4.10363 5.3838 4.10442 5.37774 4.10532L1.88216 4.62318C1.68895 4.64197 1.50471 4.71447 1.3504 4.83267C1.19073 4.95498 1.06995 5.12096 1.00269 5.31051C0.935425 5.50006 0.924572 5.70505 0.971441 5.90065C1.01813 6.09548 1.1201 6.27267 1.26506 6.41092L3.82384 8.87974L3.82967 8.88527C3.83332 8.88869 3.83607 8.89296 3.83765 8.89771C3.83923 8.90245 3.8396 8.90752 3.83872 8.91244L3.83816 8.91571L3.22842 12.4841C3.19492 12.6775 3.21613 12.8773 3.28994 13.0591C3.36385 13.2413 3.48741 13.399 3.64654 13.5144C3.80568 13.6297 3.994 13.6981 4.19008 13.7117C4.38577 13.7253 4.58135 13.6838 4.75465 13.592L4.7557 13.5914L7.90518 11.9269C7.91647 11.922 7.92868 11.9194 7.94103 11.9194C7.95338 11.9194 7.96558 11.922 7.97688 11.9269L11.1263 13.5914C11.2997 13.6835 11.4961 13.7254 11.6919 13.7117C11.888 13.6981 12.0763 13.6297 12.2355 13.5144C12.3946 13.399 12.5182 13.2413 12.5921 13.0591C12.6659 12.8773 12.6872 12.6785 12.6538 12.4852L12.6536 12.4841L12.0439 8.9157L12.0433 8.91244C12.0424 8.90752 12.0428 8.90245 12.0444 8.89771C12.0459 8.89297 12.0487 8.88869 12.0523 8.88527L12.0582 8.87974L14.617 6.41089C14.7619 6.27264 14.8639 6.09547 14.9106 5.90065C14.9574 5.70505 14.9466 5.50006 14.8793 5.31051C14.8121 5.12096 14.6913 4.95498 14.5316 4.83267C14.3773 4.71447 14.1931 4.64197 13.9999 4.62318L10.5043 4.10532C10.4982 4.10442 10.4921 4.10363 10.4861 4.10296C10.4843 4.10277 10.4827 4.10212 10.4812 4.10109C10.4798 4.10006 10.4787 4.09867 10.478 4.09708C10.4752 4.09065 10.4722 4.08429 10.4691 4.07799L8.88149 0.872887C8.79791 0.695839 8.66602 0.545925 8.50095 0.440458C8.33373 0.333623 8.13944 0.276855 7.94101 0.276855Z'
                        fill='var(--clr-primary-web)'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_1544_1701'>
                        <rect width='14' height='14' fill='white' transform='translate(0.94104)' />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export const CalenderPlusIcon = ({ className = '', color = 'var(--clr-primary-web)' }) => {
    return (
        <div className={cn(className)}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clipPath='url(#clip0_861_2456)'>
                    <path d='M1.66628 2.64288C1.38211 2.64288 1.1096 2.75577 0.908663 2.95669C0.707731 3.15763 0.594849 3.43015 0.594849 3.71431V13.8929C0.594849 14.177 0.707731 14.4496 0.908663 14.6505C1.1096 14.8514 1.38211 14.9643 1.66628 14.9643H13.452C13.7361 14.9643 14.0087 14.8514 14.2096 14.6505C14.4105 14.4496 14.5234 14.177 14.5234 13.8929V3.71431C14.5234 3.43015 14.4105 3.15763 14.2096 2.95669C14.0087 2.75577 13.7361 2.64288 13.452 2.64288H11.3091' stroke='#DF0002' strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M3.80908 1.03571V4.24999' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M11.3091 1.03571V4.24999' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M3.80908 2.64288H9.16622' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M10.2376 9.07141H4.88049' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M7.55908 6.39288V11.75' stroke={color} strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                </g>
                <defs>
                    <clipPath id='clip0_861_2456'>
                        <rect width='15' height='15' fill='white' transform='translate(0.05896 0.5)' />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};
// #endregion Filter bike in location eu

// #region Detail bike EU
const IconSmartphoneHolder = ({ color = 'var(--clr-white)' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='10'
            height='14'
            viewBox='0 0 10 14'
            fill='none'
        >
            <path
                d='M8.33508 1.04028H1.91688C1.4105 1.04028 1 1.45079 1 1.95717V12.0429C1 12.5492 1.4105 12.9598 1.91688 12.9598H8.33508C8.84147 12.9598 9.25197 12.5492 9.25197 12.0429V1.95717C9.25197 1.45079 8.84147 1.04028 8.33508 1.04028Z'
                stroke='#FAFAFA'
                strokeWidth='1.07143'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.66736 3.00012H5.58424'
                stroke={color}
                strokeWidth='1.07143'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
const IconETC = ({ color = 'var(--clr-white)' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='15'
            height='14'
            viewBox='0 0 15 14'
            fill='none'
        >
            <g clipPath='url(#clip0_861_2320)'>
                <mask
                    id='mask0_861_2320'
                    style={{ maskType: 'luminance' }}
                    maskUnits='userSpaceOnUse'
                    x='0'
                    y='0'
                    width='15'
                    height='14'
                >
                    <path d='M14.252 0H0.251953V14H14.252V0Z' fill='white' />
                </mask>
                <g mask='url(#mask0_861_2320)'>
                    <path
                        d='M12.752 0.5H1.75195C1.15195 0.5 0.751953 0.9 0.751953 1.5V12.5C0.751953 13.1 1.15195 13.5 1.75195 13.5H12.752C13.352 13.5 13.752 13.1 13.752 12.5V1.5C13.752 0.9 13.352 0.5 12.752 0.5Z'
                        stroke='#FAFAFA'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.25195 3.5H3.25195V0.5'
                        stroke={color}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.252 0.5V3.5H7.25195V0.5'
                        stroke={color}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M0.751953 6H13.752'
                        stroke={color}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <path
                    d='M3.35193 11.5V7.90002H5.65193V8.40002H3.85193V9.50002H5.35193V10H3.85193V11.1H5.65193V11.6H3.35193V11.5Z'
                    fill={color}
                />
                <path
                    d='M7.55188 8.40002V11.5H7.05188V8.40002H6.05188V7.90002H8.55188V8.40002H7.55188Z'
                    fill={color}
                />
                <path
                    d='M11.4519 10.9C11.4519 11 11.2519 11.2 11.1519 11.3C11.0519 11.4 10.9519 11.5 10.7519 11.5C10.6519 11.5 10.4519 11.5 10.2519 11.5C10.0519 11.5 9.85189 11.5 9.75189 11.5C9.55189 11.5 9.45189 11.3 9.35189 11.2C9.35189 11.2 9.15189 11 9.15189 10.9C9.15189 10.9 9.15189 10.7 9.05189 10.6C8.95189 10.5 9.05189 10.4 9.05189 10.2C9.05189 10.1 9.05189 9.90002 9.05189 9.70002C9.05189 9.50002 9.05189 9.40002 9.05189 9.20002C9.05189 9.00002 9.05189 8.90002 9.05189 8.80002C9.05189 8.70002 9.05189 8.60002 9.15189 8.50002C9.15189 8.50002 9.25189 8.30002 9.35189 8.20002C9.45189 8.10002 9.65189 8.00002 9.75189 7.90002C9.95189 7.90002 10.0519 7.90002 10.2519 7.90002C10.5519 7.90002 10.8519 7.90002 11.0519 8.20002C11.2519 8.40002 11.4519 8.70002 11.4519 9.00002H10.8519C10.8519 8.80002 10.7519 8.70002 10.6519 8.60002C10.5519 8.50002 10.3519 8.40002 10.1519 8.40002C9.95189 8.40002 9.95189 8.40002 9.85189 8.40002C9.85189 8.40002 9.65189 8.40002 9.65189 8.60002C9.65189 8.60002 9.65189 8.60002 9.55189 8.80002C9.55189 8.80002 9.55189 8.90002 9.55189 9.00002C9.55189 9.00002 9.55189 9.20002 9.55189 9.30002C9.55189 9.40002 9.55189 9.60002 9.55189 9.80002C9.55189 10 9.55189 10.1 9.55189 10.3C9.55189 10.4 9.55189 10.5 9.55189 10.6V10.8C9.55189 10.8 9.55189 10.9 9.65189 11C9.65189 11 9.75189 11.1 9.85189 11.2C9.95189 11.3 10.0519 11.2 10.1519 11.2C10.3519 11.2 10.5519 11.2 10.6519 11C10.7519 10.8 10.8519 10.7 10.8519 10.6H11.4519C11.4519 10.8 11.4519 10.9 11.2519 11.1L11.4519 10.9Z'
                    fill='#FAFAFA'
                />
            </g>
            <defs>
                <clipPath id='clip0_861_2320'>
                    <rect
                        width='14'
                        height='14'
                        fill='white'
                        transform='translate(0.251953)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
const IconUsbCharger = ({ color = 'var(--clr-white)' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='7'
            height='16'
            viewBox='0 0 7 16'
            fill='none'
        >
            <g clipPath='url(#clip0_861_2336)'>
                <path
                    d='M5.50223 4.09963H4.98257V0.82998C4.98257 0.64772 4.83485 0.5 4.65259 0.5H1.4267C1.24473 0.5 1.09672 0.648048 1.09672 0.82998V4.09963H0.577056C0.258356 4.09963 0 4.35799 0 4.67669V10.107C0 10.8698 0.618324 11.4881 1.38109 11.4881H2.09688V15.3957C2.09688 15.4533 2.14356 15.5 2.20116 15.5H3.69731C3.7549 15.5 3.80158 15.4533 3.80158 15.3957V11.4881H4.69816C5.46092 11.4881 6.07929 10.8697 6.07929 10.107V4.67669C6.07929 4.35799 5.82093 4.09963 5.50223 4.09963ZM3.83477 7.43902L2.48298 9.10981C2.44688 9.15444 2.37533 9.11928 2.38858 9.06345L2.77001 7.45646C2.77801 7.42274 2.75257 7.39033 2.71791 7.39009L2.29259 7.38734C2.24739 7.38705 2.22261 7.33467 2.25104 7.29951L3.60283 5.62873C3.63893 5.58414 3.71043 5.61925 3.69718 5.67508L3.31576 7.28207C3.30776 7.31579 3.33324 7.34824 3.3679 7.34845L3.79322 7.3512C3.83838 7.35148 3.8632 7.40387 3.83477 7.43902ZM4.45191 4.09963H1.62734V1.03066H4.45191V4.09963Z'
                    fill='#FAFAFA'
                />
                <path
                    d='M4.12914 2.01782H3.30505V2.84191H4.12914V2.01782Z'
                    fill={color}
                />
                <path
                    d='M2.77428 2.01782H1.9502V2.84191H2.77428V2.01782Z'
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id='clip0_861_2336'>
                    <rect
                        width='6.07929'
                        height='15'
                        fill='white'
                        transform='translate(0 0.5)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
const IconTopBox = ({ color = 'var(--clr-white)' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
        >
            <g clipPath='url(#clip0_861_2343)'>
                <path
                    d='M7.57935 1.03577V5.32148'
                    stroke={color}
                    strokeWidth='1.07143'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M0.615112 5.32141H14.5437V13.8928C14.5437 14.177 14.4308 14.4496 14.2299 14.6504C14.029 14.8513 13.7564 14.9643 13.4723 14.9643H1.68654C1.40238 14.9643 1.12986 14.8513 0.928926 14.6504C0.727995 14.4496 0.615112 14.177 0.615112 13.8928V5.32141Z'
                    stroke={color}
                    strokeWidth='1.07143'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M0.615112 5.32148L2.22226 2.22505C2.39552 1.87606 2.66065 1.58091 2.98914 1.37135C3.31763 1.1618 3.69703 1.04578 4.08654 1.03577H11.0723C11.4709 1.03598 11.8616 1.1474 12.2005 1.35749C12.5393 1.56759 12.8127 1.86804 12.9901 2.22505L14.5437 5.32148'
                    stroke={color}
                    strokeWidth='1.07143'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_861_2343'>
                    <rect
                        width='15'
                        height='15'
                        fill='white'
                        transform='translate(0.0793457 0.5)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
// #endregion Detail bike EU

// #region Account CMS
const IconUserCode = ({
    color = 'var(--text-gray-1)',
    parentClassName = '',
    width = '1.4970703125em',
    height = '1em'
}) => {
    return (
        <div className={cn('text-[20px]', parentClassName)}>
            <svg
                style={{
                    verticalAlign: 'middle',
                    overflow: 'hidden'
                }}
                fill={color}
                width={width}
                height={height}
                viewBox='0 0 1533 1024'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M1190.8335723 106.66666665H335.5223953A122.323915 122.323915 0 0 0 213.3333333 228.85572865v549.844651a122.311656 122.311656 0 0 0 122.189062 122.176803h855.311177a122.287137 122.287137 0 0 0 122.176803-122.176803V228.85572865A122.311656 122.311656 0 0 0 1190.8335723 106.66666665z m61.076143 672.033713a61.174217 61.174217 0 0 1-61.088402 61.100661H335.5223953a61.186476 61.186476 0 0 1-61.088401-61.100661V228.86798865a61.174217 61.174217 0 0 1 61.088401-61.100661h855.311177a61.161958 61.161958 0 0 1 61.076143 61.088401z m0 0'
                />
                <path
                    d='M1075.3871593 527.97190565c33.002203-28.037161 54.38253-69.277655 54.382531-115.826453a152.727133 152.727133 0 1 0-305.454267 0c0 46.585576 21.368068 87.789292 54.370271 115.826453-68.517575 35.687003-115.470932 107.232641-115.470932 189.640073a30.55033 30.55033 0 1 0 61.100661 0 152.739393 152.739393 0 1 1 305.466526 0 30.55033 30.55033 0 0 0 61.100661 0c0-82.407432-46.965616-153.95307-115.458673-189.640073z m-190.020113-115.826453a91.638732 91.638732 0 1 1 91.626473 91.638731 91.626473 91.626473 0 0 1-91.626473-91.638731z m-152.739393-91.650992h-366.554927a30.55033 30.55033 0 0 0 0 61.100661h366.554927a30.55033 30.55033 0 1 0 0-61.100661z m-30.55033 152.739393H366.0727263a30.55033 30.55033 0 1 0 0 61.088402h336.004597a30.55033 30.55033 0 1 0 0-61.088402z m-91.638732 152.751652H366.0727263a30.55033 30.55033 0 1 0 0 61.100661h244.365865a30.55033 30.55033 0 1 0 0-61.100661z m0 0'
                />
            </svg>
        </div>
    );
};

const IconAge = ({ color = 'var(--text-gray-1)', parentClassName = '', width = '1em', height = '1em' }) => {
    return (
        <div className={cn('text-[20px]', parentClassName)}>
            <svg
                style={{
                    verticalAlign: 'middle',
                    overflow: 'hidden'
                }}
                width={width}
                height={height}
                fill={color}
                viewBox='0 0 1024 1024'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path d='M928 832h-32V448a64 64 0 0 0-64-64h-96V256a32 32 0 0 0-64 0v128H544V256a32 32 0 0 0-64 0v128H352V256a32 32 0 0 0-64 0v128h-96a64 64 0 0 0-64 64v384H96a32 32 0 0 0 0 64h832a32 32 0 0 0 0-64zM192 576h640v256H192z m96-128h544v64H192v-64z' />
                <path d='M320 160m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z' />
                <path d='M512 160m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z' />
                <path d='M704 160m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z' />
            </svg>
        </div>
    );
};
// #endregion Account CMS

export {
    RightArrowIcon,
    SearchIcon,
    StarIcon,
    FlagLocation,
    PinLocation,
    SearchIconCurrent,
    IconSmartphoneHolder,
    IconETC,
    IconUsbCharger,
    IconTopBox,
    // account cms
    IconUserCode,
    IconAge
};
